import _sfc_main from "./DayViewAfter.vue2.js";
/* empty css                  */
import _export_sfc from "../../../_virtual/_plugin-vue_export-helper.js";
const DayViewAfter = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-d8c74c15"]]);
export {
  DayViewAfter as default
};
//# sourceMappingURL=DayViewAfter.vue.js.map
